import React from 'react';
import { withRouter } from 'react-router-dom';

class FooterComponent extends React.Component {
    // constructor(props) {
    //     super(props)
    // }
    shouldComponentUpdate(prevProps, nextState) {
        // if (localStorage.getItem('access_token')) {
        //     this.isAuthenticated = true
        //     // $("#myModal").modal("hide"); 
        // } else {
        //     this.isAuthenticated = false
        // }
        return true
    }

    render() {
        return (
            <div>
                {/* <footer className="pt-5 bg-dark-gray">
                    
                </footer> */}
            </div>
        )
    }
}

export default withRouter(FooterComponent)
